import { PureComponent, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isBrowser, isTablet } from 'react-device-detect';
import { Formik } from 'formik';
import moment from 'moment';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import AvField from 'availity-reactstrap-validation/lib/AvField';

import {
  Button,
  Grid,
  Icon,
  Label,
  Modal,
  Radio,
  Segment,
  Tab,
  Form,
  Checkbox,
} from 'semantic-ui-react';

import {
  getAllQuestions,
  getOutcomes,
  getDomains,
  updateQuestions,
} from '../../../../store/actions';

import { map, get } from '../../../../utils/lodash';
import { CustomTable } from '../../../../components';
import MultiLanguageCKEditor from '../../../../components/form/inputs/multiLanguageCKEditor';
import { SUPPORTED_LANGUAGES } from '../../../../i18n';

import {
  initialValues,
  evaluationQuestionValidation,
  convertToBackendFormat,
} from '../../../../validations/evaluationQuestionValidation';

class SelectOutcome extends PureComponent {
  componentDidMount() {
    const { getOutcomes, getDomains } = this.props;
    getOutcomes();
    getDomains();
  }

  renderOutcomeChild(id) {
    const { outcomes } = this.props;
    return map(outcomes, (item, i) => {
      if (id !== item.policyId) return null;
      if (item.isEnable === 0) return null;
      return (
        <option key={i} value={item.id}>
          {item.title}
        </option>
      );
    });
  }

  renderOutcome(domains) {
    return map(domains, (domain, i) => {
      return (
        <optgroup key={i} label={domain.policyName} value={domain.id}>
          {this.renderOutcomeChild(domain.id)}
        </optgroup>
      );
    });
  }

  render() {
    const { t, domains, setOutcome } = this.props;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <AvField
              className="org-inputs"
              type="select"
              name="select"
              label={t('formulary.placeholder.select_outcome')}
              onChange={(e) => setOutcome(e)}
            >
              <option value="" disabled defaultValue>
                {t('formulary.placeholder.select_outcome')}
              </option>
              {this.renderOutcome(domains)}
            </AvField>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
class EvaluationQuestionsGraded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      outputId: null,
    };
  }

  setOutcome({ target }) {
    this.setState({
      outputId: target.value,
    });
  }

  render() {
    return (
      <div className="eval-qs-admin">
        <div>
          <div>
            <AvForm
              ref={(c) => (this.form = c)}
              onValidSubmit={(event, values) =>
                this.handleValidSubmit(event, values)
              }
              className="venue-form"
            >
              <SelectOutcome
                setOutcome={(e) => this.setOutcome(e)}
                {...this.props}
              />
            </AvForm>
          </div>
        </div>
        <EvaluationQuestionList
          {...this.props}
          outputId={this.state.outputId}
        />
      </div>
    );
  }
}

class EvaluationQuestionList extends PureComponent {
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      isEnable: false,
      columns: [
        {
          title: t('admin.evaluation_question.label'),
          render: (data) => {
            return (
              <div className="blocked-badge-container">
                <div className={!data.isEnable && 'disabled'}>
                  {data.method.details}
                </div>
                {!data.isEnable && (
                  <Label className="blocked-badge" color="red" size="tiny">
                    {t('common.disabled')}
                  </Label>
                )}
              </div>
            );
          },
          width: 8,
        },
        {
          title: <div>{t('common.created_date')}</div>,
          render: (data) => {
            return (
              <div className={!data.isEnable && 'disabled'}>
                {moment(data.createdAt).format('ll hh:mm A')}
              </div>
            );
          },
          width: 3,
        },
        {
          title: <div>{t('common.updated_date')}</div>,
          render: (data) => {
            return (
              <div className={!data.isEnable && 'disabled'}>
                {moment(data.updatedAt).format('ll hh:mm A')}
              </div>
            );
          },
          width: 3,
        },
        {
          title: <div></div>,
          render: (data) => {
            return (
              <EditQuestionModal
                item={data}
                {...this.props}
                currentPage={this.state.currentPage}
              />
            );
          },
          width: 2,
          textAlign: isBrowser || isTablet ? 'center' : null,
        },
      ],
      currentPage: 1,
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    const { outputId, getAllQuestions } = this.props;
    const { currentPage } = this.state;
    try {
      if (prevProps.outputId !== outputId) {
        await getAllQuestions(currentPage, outputId, true);
      }
    } catch (error) {}
  }

  async componentDidMount() {
    try {
      const { currentPage } = this.state;
      const { getAllQuestions } = this.props;
      await getAllQuestions(currentPage, null, true);
    } catch (error) {}
  }

  pageChange(page) {
    const { getAllQuestions } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        getAllQuestions(page, null, true);
      }
    );
  }

  render() {
    const { t, questions, listLoading } = this.props;
    const { columns, currentPage } = this.state;

    return (
      <Segment
        className="super-admin-content-segment"
        loading={listLoading}
        disabled={listLoading}
      >
        {questions.docs && questions.docs.length ? (
          <CustomTable
            header
            columns={columns}
            data={questions.docs}
            pagination
            customClass="super-admin-table tbody-hover"
            handlePaginationChange={(page) => this.pageChange(page)}
            page={currentPage}
            noOfPages={questions.pages}
            keyExtractor={(item, index) => item.id}
          />
        ) : (
          <div className="no-ques">
            {t('formulary.placeholder.select_outcome')}
          </div>
        )}
      </Segment>
    );
  }
}

class EditQuestionModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }
  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  editSelected(item) {
    this.setState({
      form: item,
    });
  }

  render() {
    const { modal } = this.state;
    const { t, item } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={
          <label
            className="activity-actions-warn mb-0"
            onClick={() => this.editSelected(item)}
          >
            <Icon name="edit" />
            {t('common.edit')}
          </label>
        }
        className="edit-interview"
      >
        <Modal.Header>
          {t('actions.edit')} {get(item.method, 'details', '')}
        </Modal.Header>
        <Modal.Content>
          <EditQuestionForm
            form={item}
            toggle={() => this.toggle()}
            {...this.props}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

class EditQuestionForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentLanguage: 'en',
    };
  }

  async handleValidSubmit(values) {
    try {
      const { updateQuestions, form, toggle, currentPage } = this.props;
      const legacyData = convertToBackendFormat(values);

      await updateQuestions(
        form.outcomeId,
        form.methodId,
        legacyData,
        currentPage,
        true
      );
      toggle();
    } catch (error) {
      console.error('Error: EditQuestionForm ~ handleValidSubmit', error);
    }
  }

  // Get reference values for translation
  getReferenceValue = (fieldName, values) => {
    if (this.state.currentLanguage === 'en') {
      return '';
    }
    return values[fieldName]?.en || '';
  };

  render() {
    const { toggle, questionLoading, form, t } = this.props;

    return (
      <div className="multilingual-question-form">
        <Formik
          onSubmit={(values) => this.handleValidSubmit(values)}
          initialValues={initialValues(form)}
          validationSchema={evaluationQuestionValidation(t)}
          context={{ isMultiLang: true }}
        >
          {({ handleSubmit, values, setFieldValue }) => {
            // Create language tabs
            const languageTabs = SUPPORTED_LANGUAGES.map((lang) => ({
              menuItem: {
                key: lang.locale,
                content: (
                  <span>
                    {lang.flag} {lang.name}
                    {lang.locale === 'en' && (
                      <span style={{ color: '#f39c12' }}> *</span>
                    )}
                  </span>
                ),
              },
              render: () => (
                <Tab.Pane key={lang.locale}>
                  <Form onSubmit={handleSubmit} className="venue-form">
                    <MultiLanguageCKEditor
                      id="preamble"
                      name="preamble"
                      labelText={t(
                        'admin.activity_settings.evaluation_questions.introduction_outcome_measure'
                      )}
                      requiredStar
                      currentLanguage={lang.locale}
                      referenceValue={this.getReferenceValue(
                        'preamble',
                        values
                      )}
                    />

                    <div className="gap-between-ck">
                      <MultiLanguageCKEditor
                        id="question1"
                        name="question1"
                        labelText={t(
                          'admin.activity_settings.evaluation_questions.question_1'
                        )}
                        requiredStar
                        currentLanguage={lang.locale}
                        referenceValue={this.getReferenceValue(
                          'question1',
                          values
                        )}
                      />
                    </div>

                    {values.cumulative && (
                      <div className="gap-between-ck">
                        <MultiLanguageCKEditor
                          id="question2"
                          name="question2"
                          labelText={t(
                            'admin.activity_settings.evaluation_questions.question_2'
                          )}
                          requiredStar={values.cumulative}
                          currentLanguage={lang.locale}
                          referenceValue={this.getReferenceValue(
                            'question2',
                            values
                          )}
                        />
                      </div>
                    )}

                    {lang.locale === 'en' && (
                      <>
                        <div className="gap-between-ck">
                          <div className="grantee-checkbox-outcome">
                            <Checkbox
                              label={t(
                                'admin.activity_settings.evaluation_questions.post_pre_test_question'
                              )}
                              checked={values.cumulative}
                              onChange={(e, { checked }) => {
                                setFieldValue('cumulative', checked);
                              }}
                            />
                          </div>
                        </div>

                        <div className="edit-outcome-status-bar enable-question">
                          <div className="two-step-radio-container-admin status-right">
                            <Radio
                              toggle
                              className="modal-toggle-qs-participant"
                              checked={values.isEnable}
                              onChange={() =>
                                setFieldValue('isEnable', !values.isEnable)
                              }
                            />
                          </div>
                          <label>
                            {t(
                              'admin.activity_settings.evaluation_questions.enable'
                            )}
                          </label>
                        </div>
                      </>
                    )}

                    <div className="model-buttons">
                      <Button
                        className="Secondary-Button"
                        type="button"
                        onClick={() => toggle()}
                      >
                        {t('actions.cancel')}
                      </Button>
                      <Button
                        content={t('actions.save')}
                        type="submit"
                        className="Primary-Button"
                        loading={questionLoading}
                        disabled={questionLoading}
                      />
                    </div>
                  </Form>
                </Tab.Pane>
              ),
            }));

            return (
              <Tab
                panes={languageTabs}
                onTabChange={(e, { activeIndex }) => {
                  const selectedLang = SUPPORTED_LANGUAGES[activeIndex];
                  this.setState({ currentLanguage: selectedLang.locale });
                }}
              />
            );
          }}
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    outcomes: state.extra.outcomes,
    questions: state.admin.questionsGraded,
    domains: state.admin.domains,
    questionLoading: state.admin.questionLoading,
    listLoading: state.admin.listLoadingGraded,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getAllQuestions,
      getOutcomes,
      getDomains,
      updateQuestions,
    },
    dispatch
  );
};

EvaluationQuestionsGraded = connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationQuestionsGraded);

EvaluationQuestionsGraded = withTranslation()(EvaluationQuestionsGraded);

export default EvaluationQuestionsGraded;
